export const convertStorageCapacityToGB = (storageCapacity: string) => {
  const units = { GB: 1, TB: 1024 };
  const unitPattern = '[a-zA-Z]+';
  const valuePattern = /\d+/;

  const unitMatch = storageCapacity.toUpperCase().match(unitPattern);
  const valueMatch = storageCapacity.toUpperCase().match(valuePattern);

  if (!unitMatch || !valueMatch) {
    return 0;
  }

  const unit = unitMatch[0];
  const value = parseInt(valueMatch[0]);

  return value * (units[unit] ?? 1);
};
